export type DashboardCamera = {
  id: string
  status: 'Live' | 'Warning' | 'Offline'
}

export type DashboardRuntime = {
  state: 'stopped' | 'running' | 'error'
  error?: string
}

export async function loadDashboardStatus() {
  const [cameras, runtime] = await Promise.all([
    fetch('/api/cameras').then(async (response) => {
      if (!response.ok) throw new Error('Camera list unavailable')
      return response.json() as Promise<DashboardCamera[]>
    }),
    fetch('/api/workflow/runtime').then(async (response) => {
      if (!response.ok) throw new Error('Workflow runtime unavailable')
      return response.json() as Promise<DashboardRuntime>
    }),
  ])
  return { cameras, runtime }
}
